import { render, staticRenderFns } from "./parkvehicletyperule.vue?vue&type=template&id=0057adc2&"
import script from "./parkvehicletyperule.vue?vue&type=script&lang=js&"
export * from "./parkvehicletyperule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports